import { trackClickEvent } from '@/components/account/PlayKitSchedule/utils';
import { GenExternalLink } from '@/components/generics';
import { GenInternalLink } from '@/components/generics/GenInternalLink';
import Heading, {
  HeadingSize,
  HeadingTag,
} from '@/components/ui/Heading/Heading';
import { getAssetForProduct } from '@/lib/api/productCatalog/helpers/playKitProductAssetHelpers';
import { TypeProduct } from '@/lib/api/productCatalog/types';
import { CTA_NAMES } from '@/utils/rudderstack';
import Image from 'next/image';

export interface InsideYourPlayKitProps {
  title: string;
  linkCopy: string;
  linkHref: string;
  showCustomize: boolean;
  customizeCopy: string;
  customizeHref: string;
  products: TypeProduct[] | undefined;
}

function InsideYourPlayKit({
  title,
  linkCopy,
  linkHref,
  showCustomize,
  customizeCopy,
  customizeHref,
  products,
}: InsideYourPlayKitProps) {
  // Sort products where those with customizable options appear first
  const sortedProducts = products
    ?.slice()
    .sort(
      (a, b) =>
        Number(!!b.customizable_options?.length) -
        Number(!!a.customizable_options?.length),
    );
  return (
    <div className="pb-5">
      <div className="flex md:flex-row flex-col items-left md:items-center justify-start md:gap-4 gap-0.5 pb-4">
        <Heading
          classes="w-max"
          tag={HeadingTag.H4}
          size={HeadingSize.H4}
          text={title}
        />
        <GenInternalLink
          classes="text-lg"
          href={linkHref}
          cta={linkCopy}
          onClick={() => {
            trackClickEvent(CTA_NAMES.REPLACEMENT_PARTS);
          }}
        />
      </div>
      <div className="flex flex-row justify-between gap-2 md:gap-4 flex-nowrap overflow-x-scroll scroll-smooth">
        {sortedProducts &&
          sortedProducts.map((product, index) => (
            <div
              key={index}
              className="flex flex-col md:min-w-[128px] min-w-[112px] min-h-[180px]"
            >
              <Image
                className="md:min-w-[128px] md:min-h-[128px] min-w-[112px] min-h-[112px] object-contain bg-blue-light mb-2"
                src={getAssetForProduct(product)?.uri || ''}
                alt={product.name}
                height={128}
                width={128}
              />
              <p className="text-sm font-bold w-full">{product.name}</p>
              {product.customizable_options &&
                product.customizable_options.length > 0 &&
                showCustomize && (
                  <span className="text-sm">
                    <GenExternalLink href={customizeHref} cta={customizeCopy} />
                  </span>
                )}
            </div>
          ))}
      </div>
    </div>
  );
}

export default InsideYourPlayKit;
